import { makeAutoObservable, runInAction } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants"
import moment from "moment";

import { ErrorWrapper } from "../utils/ErrorWrapper"
import { normalizeAmount } from "../utils/money"

interface Obj {
  [key: string]: any;
}


interface Bill {
  id: number;
  accountNumber: string | null;
  paymentDate: string | null;
  paymentReference: string | null;
  premiseDetails: string | null;
  customerName: string | undefined;
  paymentStatus: string | null;
}

interface Payment {
  id: number;
  accountNumber: string | null;
  paymentDate: string | null;
  paymentReference: string | null;
  premiseDetails: string | null;
  customerName: string | undefined;
  paidAmount: string | null;
}

interface PostDatedCheque {
  id: number;
  accountNumber: string | null;
  ppId: string | null;
  sewerageNumber: string | null;
  premiseDetails: string | null;
  createdDate: string | null;
  chqDate: string | null;
  chqNumber: string | null;
  bankNameAccount: string | undefined;
  chqAmount: string | null;
  status: string | null;
}

interface BillData {
  [key: string]: string | undefined;
}

function downloadPDF(pdf: string) {


  const linkSource = `data:application/pdf;base64,${pdf}`;
  const downloadLink = document.createElement("a");
  const fileName = "abc.pdf";
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

class PaymentReceipts {
  data = {};
  bills: Bill[] = [];
  payments: Payment[] = []
  accountSummary: any[] = []
  postDatedCheques: PostDatedCheque[] = []
  pendingPayments: Obj[] = []

  billpayment: Obj = {}

  constructor() {
    makeAutoObservable(this);
  }

  getBillHistory = ErrorWrapper(async (data: BillData) => {

    const newData = {
      ...data,
      currentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US"
    }


    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.BILL_HISTORY, type: 'GET', data: newData });

    const temp = res.result.output
    this.bills = []
    for (let i = 0; i < temp?.length; i++) {
      this.bills.push({
        id: i + 1,
        accountNumber: temp[i]['accountNumber'],
        paymentDate: moment(temp[i]['billDate']).format('DD-MM-YYYY'),
        paymentReference: temp[i]['billNumber'],
        premiseDetails: temp[i]['premiseAddress'],
        customerName: data.fullName,
        paymentStatus: moment(temp[i]['dueDate']) < moment(Date.now()) ? 'Paid' : 'Due'
      })
    }

  })

  getFile = ErrorWrapper(async (id: string) => {
    const data = {
      billNumber: id,
      currentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US"
    }



    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.BILL_PDF, type: 'GET', data, file: true });


    downloadPDF(res)
  })

  payBill = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.BILL_PAYMENT, type: 'POST', data });

    runInAction(() => this.billpayment = res.result)
    return res;
  })

  payBillNI = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.NI_BILL_PAYMENT, type: 'POST', data });

    runInAction(() => this.billpayment = res.result)
    return res;
  })
  payBillTabby = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.TABBY_BILL_PAYMENT, type: 'POST', data });

    runInAction(() => this.billpayment = res.result)
    return res;
  })
  payBillTamara = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.TAMARA_BILL_PAYMENT, type: 'POST', data });

    runInAction(() => this.billpayment = res.result)
    return res;
  })

  makeTabbyEligibilityCheck =ErrorWrapper(
      async (incomingDate: any) => {
        const data = {
          ...incomingDate,
          platform: "Web",
        };
    
        const res = await callRemoteMethod({
          endpoint: CONSTANTS.URL.TABBY_ELIGIBILITY,
          type: "POST",
          data,
        });
        return res;
      }
    );

  getPendingPayments = ErrorWrapper(async ({ personId, fullName }: { personId: string, fullName: string }) => {
    // console.log(personId, fullName, "main ID's -->");

    try {
      const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.PENDING_PAYMENTS, type: 'GET', data: { personId } });
      // console.log(res, "PENDING_PAYMENTS -->");

      // runInAction(()=>{this.pendingPayments = res.result.output.accountList})

      const temp = res.result.output.accountList
      let output: Obj[] = []
      this.pendingPayments = []
      if(temp?.length){
        for (let i = 0; i < 3; i++) {
          output.push({
            id: i + 1,
            accountNumber: temp[i]['accountId'],
            type: temp[i]['billType'],
            accountType: temp[i]['accountType'],
            sewerageNumber: temp[i]['premiseId'],
            premiseDetails: temp[i]['premiseAddress1'],
            premiseType: temp[i]['premiseType'] ? temp[i]['premiseType'] : 'N/A',
            customerName: fullName,
            amountDue: normalizeAmount(temp[i]['currentBalance']),
            amountToPay: normalizeAmount(temp[i]['currentBalance']),
            lastBillId: temp[i]['lastBillId'],
          })
        }
        runInAction(() => this.pendingPayments = output)
      }
    
    } catch (e) {
      runInAction(() => this.pendingPayments = [])
    }
  })

  getAllPendingPayments = ErrorWrapper(async ({ personId, returnAllAccountTypes, accountType, fullName }:
    { personId: string, returnAllAccountTypes: string, accountType: string, fullName: string }) => {
    try {
      const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.ALL_PENDING_PAYMENTS(personId, returnAllAccountTypes, accountType) });
      const temp = res.result.cmRetrieveAccountDetailsForPayment.accounts
      let output: Obj[] = []
      this.pendingPayments = []
      for (let i = 0; i < temp.length; i++) {
        output.push({
          id: i + 1,
          accountNumber: temp[i]['accountId'],
          type: temp[i]['accountType'],
          accountType: temp[i]['accountType'],
          sewerageNumber: temp[i]['premiseId'],
          premiseDetails: temp[i]['premiseDetails'],
          premiseType: temp[i]['premiseUsage'] ? temp[i]['premiseUsage'] : 'N/A',
          customerName: fullName,
          // Rounded at the boundary: these arrive as JSON floats and can carry
          // IEEE-754 drift (10.799999999999999), which the payment gateway
          // rejects further down the line.
          amountDue: normalizeAmount(temp[i]['dueAmount']),
          amountToPay: normalizeAmount(temp[i]['amountToPay']),
          //lastBillId: temp[i]['lastBillId'],
        })
      }
      runInAction(() => this.pendingPayments = output)
    } catch (e) {
      runInAction(() => this.pendingPayments = [])
    }

  })
 resetPendingPayments = () => {
   runInAction(() => this.pendingPayments = [])
 }
  getPaymentHistory = ErrorWrapper(async (data: BillData) => {
    const newData = {
      ...data,
      currentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US"
    }

    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.PAYMENT_HISTORY, type: 'GET', data: newData });

    const temp = res.result.output
    let output: Payment[] = []
    this.payments = []
    for (let i = 0; i < temp?.length; i++) {
      output.push({
        id: i + 1,
        accountNumber: temp[i]['accountId'],
        paymentDate: moment(temp[i]['paymentDate']).format('DD-MM-YYYY'),
        paymentReference: temp[i]['paymentEventId'],
        premiseDetails: temp[i]['premiseAddress'],
        customerName: data.fullName,
        paidAmount: Number(temp[i]['paymentAmount']).toFixed(2),
      })
    }
    runInAction(() => this.payments = output)
  })

  formatDate = (inputDate: any) => {
    const parts = inputDate.split('-');
    const year = parts[0];
    const month = parts[1];
    const day = parts[2]; // Set the desired day (1st)
    return `${day}-${month}-${year}`;
  }

  getAccountSummary = ErrorWrapper(async (data: any) => {
    const newData = {
      ...data,
      currentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US"
    }
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.ACCOUNT_SUMMARY, type: 'GET', data: newData });
    const temp = res.result[0]?.cmRetrieveAccountSummaryReport_IWS?.output?.reportList;
    let output: any[] = []
    this.accountSummary = []
    for (let i = 0; i < temp?.length; i++) {
      output.push({
        id: i + 1,
        paymentStatus: temp[i]['statusDescription'],
        reportId: temp[i]['reportId'],
        type: temp[i]['type'],
        // paymentDate: (temp[i]['requestDate']?.split('-')?.slice(0, 3)),
        paymentDate: this.formatDate(temp[i]['requestDate']),
      })
    }
    runInAction(() => this.accountSummary = output)
  })

  getPaymentPDF = ErrorWrapper(async (id: string) => {
    await callRemoteMethod({ endpoint: CONSTANTS.URL.PAYMENT_PDF + id });
  })

  generateRequest = ErrorWrapper(async (data: any) => {
    const { parcelId, personId, userName, accType } = data;
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.GENERATE_REQUEST(parcelId, personId, userName, accType) });
    return res;
  })

  getPostDatedCheques = ErrorWrapper(async (data: BillData) => {
    const newData = {
      ...data,
      currentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US"
    }
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.ALL_PDC_RECEIPTS, type: 'GET', data: newData });

    const temp = res.result.output
    let output: PostDatedCheque[] = []
    this.postDatedCheques = []
    for (let i = 0; i < temp?.length; i++) {
      output.push({
        id: i + 1,
        accountNumber: temp[i]['accountId'],
        ppId: temp[i]['ppId'],
        sewerageNumber: temp[i]['ppId'],
        premiseDetails: temp[i]['premiseAddress'],
        createdDate: this.formatDate(temp[i]['creationDateTime']),
        chqDate: moment(temp[i]['checkAccountingDate'])?.format('DD-MM-YYYY'),
        bankNameAccount: temp[i]['tenderType'],
        chqAmount: Number(temp[i]['pdcAmount']).toFixed(2),
        chqNumber: temp[i]['checkNumber'],
        status: temp[i]['pdcStatusDescription'],
      })
    }
    runInAction(() => this.postDatedCheques = output)
  })
}

const paymentReceiptsStore = new PaymentReceipts()
export default paymentReceiptsStore;
